import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IntermediateCommunicationRequest, CommunicationResponse } from '../models/communication.model';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private http = inject(HttpClient);

  sendIntermediateCommunication(request: IntermediateCommunicationRequest): Observable<HttpResponse<CommunicationResponse>> {
    const endpoint = `${environment.baseUrl}/incidents/v1/triggerCommunication`;
    return this.http.post<CommunicationResponse>(endpoint, request, { observe: 'response', responseType: 'json' });
  }
}
